import ConsultarProvider from "../providers/consultar-provider";
import TokenProvider from "../../commons/providers/token-provider";

class ConsultarRepository {
    
    constructor() {
        this.consultarProvider = new ConsultarProvider();
        this.tokenProvider = new TokenProvider();
    }

    postConsultarCreateSimulacion = async (datosConsulta) => {
        await this.tokenProvider.getToken();
        return this.consultarProvider.postConsultarCreateSimulacion(datosConsulta);
    }

}

export default ConsultarRepository;